import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';

/**
 * Intercepts all HTTP requests and prefixes them with a base url (if necessary).
 */
@Injectable()
export class UrlInterceptor implements HttpInterceptor {
  /** Inject services. */
  private readonly envService = inject(EnvironmentService);

  /**
   * Append a base url to all relative calls.
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Skip absolute URLs
    if (req.url.startsWith('http')) {
      return next.handle(req);
    }

    // Point to the tool service by default
    const apiReq = req.clone({
      url: `${this.envService.toolServiceUrl}/${req.url}`,
    });
    return next.handle(apiReq);
  }
}
